import(/* webpackMode: "eager", webpackExports: ["CodeSample"] */ "/Users/carl/Source/Repos/ThreadHound/pw.community.bot/app/(shopfront)/developers/components/CodeSample.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/carl/Source/Repos/ThreadHound/pw.community.bot/node_modules/next/dist/client/app-dir/link.js");
